export default __webpack_public_path__ + "static/media/rubberGirl.febcaeec.png";